import { Injectable, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutoUnsubscribe } from '../../../../../core/decorators/auto-unsubscribe';
import { Subject ,  Subscription } from 'rxjs';
import { AuthService } from '../../../../../core/services/auth.service';
import { GlobalsService } from '../../../../../core/services/globals.service';
import { GestionOrService } from './gestion-or.service';
import { environment } from '../../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { DataSaveService } from '../../../../../core/services/data-save.service';
import { TranslateService } from '@ngx-translate/core';
import { InterventionType } from '../../../../../core/interfaces/interventionType';
import { InternalSection } from '../../../../../core/interfaces/internalSection';

@Injectable()

@AutoUnsubscribe()
export class GestionService implements OnInit {
    pais: string;
    fiscalCodeOrigen: string;
    receptionData: FormGroup;

    gestionOr: FormGroup;
    formularioPrincipal: FormGroup;
    error: string;
    code: string;
    ordenSeleccionada: any;

    ultimaOperationCode: number = 0;
    kilometrosIniciales: number;
    kilometrosMal: boolean = false;
    ordenCompleteSeleccionada: any;
    public pestana = new Subject<number>();
    public recarga = new Subject<boolean>();
    public refrescarDatos = new Subject<boolean>();
    formMode: boolean;
    modoEdicion: boolean;
    deshabilitarCampos: boolean;
    isValidEntryFiscalCode = true;
    isDuplicateFiscalCode = false;
    primerCampoST: object;
    primerCampoIT: InterventionType;
    primerCampoSI: InternalSection;
    seleccionar: string;
    isCulturePt: boolean;
    flechaRightFranquicia: boolean = true;
    flechaLeftFranquicia: boolean = false;
    private _facturaAnadida;
    constructor(
        private translateService: TranslateService,
        private _dataSaveService: DataSaveService,
        private toastr: ToastrService,
        private _authService: AuthService,
        private _gestionOrService: GestionOrService,
        private _globals: GlobalsService
    ) {
        this.pais = this._authService.getDataPais();
    }


    ngOnInit() {
        this.formMode = this._authService.getUserRole();
        if (this.formMode || !this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }
        this.crearTextos();
    }

    set ultimaOpCode(value) {
        this.ultimaOperationCode = value;
    }
    get ultimaOpCode() {
        return this.ultimaOperationCode;
    }

    set facturaAnadida(value) {
        this._facturaAnadida = value;
    }
    get facturaAnadida() {
        return this._facturaAnadida;
    }

    setModoEdicion(value) {
        this.modoEdicion = value;
    }
    observerRecarga() {
        return this.recarga.asObservable();
    }
    marcarRecarga(recarga) {
        this.recarga.next(recarga);
    }

    observerRefrescarDatos() {
        return this.refrescarDatos.asObservable();
    }
    setRefrescarDatos(value) {
        this.refrescarDatos.next(value);
    }
    observerPestana() {
        return this.pestana.asObservable();
    }
    marcarPestana(pestana) {
        this.pestana.next(pestana);
    }

    crearFormulariogestionOr() {

        const primerCampoLR = { Key: 0, Value: this.seleccionar };

        this.gestionOr = new FormGroup({
            imputation: new FormControl(primerCampoLR)
        });
    }

    get f() { return this.receptionData.controls; }

    crearTextos() {
        this.translateService.get('labels.seleccionar').subscribe(text => {
            this.seleccionar = text;


            this.primerCampoST = {
                WorkingSectionCode: '00',
                WorkingSectionDescription: this.seleccionar
            };
            this.primerCampoIT = {
                CLIENTCODE: '',
                COMPANYCODE: '',
                Description: this.seleccionar,
                INTERVENTIONCODE: '**'
            };

            this.primerCampoSI = {
                Account: '',
                CLIENTCODE: '',
                COMPANYCODE: '',
                Description: this.seleccionar,
                INTERNALSECTIONCODE: '**'
            };
        });
    }
    crearFormularioRecepcion() {
        let deshabilitar = false;
        this.isCulturePt = this._authService.getDataPais() === 'pt';
        if (this.isCulturePt) {
            deshabilitar = true;
        }

        this.crearTextos();
        const comboSectorTaller = this.primerCampoST;
        const comboSeccionInterna = this.primerCampoSI;
        const comboLineaIntervencion = this.primerCampoIT;

        const aseguradora = {
            CustomerId: null,
            CustomerName: null
        };
        const forfait = {
            LOCALFORTAITCODE: '',
            Description: ''
        };
        const comboTipoimputacion = {
            Description: 'Externa',
            SubTypeCode: '0'
        };
        this.receptionData = new FormGroup({
            Code: new FormControl({ value: this.ultimaOperationCode, disabled: true }),
            tipoImputacion: new FormControl(comboTipoimputacion),
            sectorTaller: new FormControl(comboSectorTaller, [Validators.required]),
            lineaIntervencion: new FormControl(comboLineaIntervencion),
            seccionInterna: new FormControl(comboSeccionInterna),
            notas: new FormControl('', [Validators.required]),
            // Para contenedor seguros
            aseguradora: new FormControl(aseguradora, [Validators.required]),
            expediente: new FormControl(''),
            poliza: new FormControl(''),
            descuentoSeguro: new FormControl(0.00, [Validators.maxLength(6), Validators.max(100.00)]),
            destinoFacturacion: new FormControl(false), // A 0 C  -- probando true|false
            destinoFranquicia: new FormControl({ value: 1, disabled: deshabilitar }), // 1 || 2
            destinoContabilidad: new FormControl({ value: false, disabled: deshabilitar }),

            checkFranquiciaIVA: new FormControl(false),

            peritajeBase: new FormControl(0),
            peritajeImpuesto: new FormControl(0),
            InsuranceSurveyVatCode: new FormControl('', [Validators.required]),
            peritajeTotal: new FormControl(0),

            franquiciaBase: new FormControl({ value: 0, disabled: false }),
            franquiciaImpuesto: new FormControl(0),
            InsuranceFranchiseVatCode: new FormControl('', [Validators.required]),
            franquiciaTotal: new FormControl({ value: 0, disabled: false }),
        });

        if (this.pais === 'fr') {
            this.receptionData.addControl('forfait', new FormControl(forfait));
        }
        if (this.pais === 'pt') {
            this.receptionData.get('checkFranquiciaIVA').disable();
            this.receptionData.get('destinoFranquicia').setValue(2);
        }
        // const datosForm = this.receptionData.getRawValue();
        // this.clickAllow();
    }

    setCamposEspecialesPais(){
        switch (this.pais) {
            case 'pt':
                this.receptionData.get('destinoFacturacion').setValue(false);
                this.receptionData.get('destinoFranquicia').setValue(2);
                this.receptionData.get('destinoContabilidad').setValue(false);
                this.receptionData.get('checkFranquiciaIVA').setValue(false);
                this.receptionData.get('franquiciaImpuesto').setValue(23);
                this.receptionData.get('peritajeImpuesto').setValue(23);

                this.receptionData.get('destinoFranquicia').disable();
                this.receptionData.get('destinoContabilidad').disable();
                this.receptionData.get('checkFranquiciaIVA').disable();
                break;
            case 'fr':
                this.receptionData.get('destinoFacturacion').setValue(true);
                this.receptionData.get('destinoFranquicia').setValue(2);
                this.receptionData.get('destinoContabilidad').setValue(true);
                this.receptionData.get('checkFranquiciaIVA').setValue(false);
                this.receptionData.get('franquiciaImpuesto').setValue(20);
                this.receptionData.get('peritajeImpuesto').setValue(20);

                this.receptionData.get('destinoFranquicia').enable();
                this.receptionData.get('destinoContabilidad').enable();
                this.receptionData.get('checkFranquiciaIVA').enable();
                break;
            case 'es':
                this.receptionData.get('destinoFacturacion').setValue(false);
                this.receptionData.get('destinoFranquicia').setValue(1);
                this.receptionData.get('destinoContabilidad').setValue(false);
                this.receptionData.get('checkFranquiciaIVA').setValue(false);
                this.receptionData.get('franquiciaImpuesto').setValue(21);
                this.receptionData.get('peritajeImpuesto').setValue(21);

                this.receptionData.get('destinoFranquicia').enable();
                this.receptionData.get('destinoContabilidad').enable();
                this.receptionData.get('checkFranquiciaIVA').enable();
                break;
            default:
                break;
        }
    }

    resetFormularioRecepcion() {
        this.crearTextos();
        const comboSectorTaller = this.primerCampoST;
        const comboSeccionInterna = this.primerCampoSI;
        const comboLineaIntervencion = this.primerCampoIT;

        const aseguradora = {
            CustomerId: null,
            CustomerName: null
        };
        const forfait = {
            LOCALFORTAITCODE: '',
            Description: ''
        };
        const comboTipoimputacion = {
            Description: 'Externa',
            SubTypeCode: '0'
        };
        this.receptionData = new FormGroup({
            Code: new FormControl({ value: this.ultimaOperationCode, disabled: true }),
            tipoImputacion: new FormControl(comboTipoimputacion),
            // forfait: new FormControl(),
            sectorTaller: new FormControl(comboSectorTaller, [Validators.required]),
            lineaIntervencion: new FormControl(comboLineaIntervencion),
            seccionInterna: new FormControl(comboSeccionInterna),
            notas: new FormControl('', [Validators.required]),

            aseguradora: new FormControl(aseguradora),
            expediente: new FormControl(''),
            poliza: new FormControl(''),
            descuentoSeguro: new FormControl(0.00, [Validators.maxLength(6), Validators.max(100.00)]),
            destinoFacturacion: new FormControl(false), // A 0 C  -- probando true|false
            destinoFranquicia: new FormControl(1),
            destinoContabilidad: new FormControl(false),

            checkFranquiciaIVA: new FormControl(false),

            peritajeBase: new FormControl(0),
            peritajeImpuesto: new FormControl(0),
            peritajeTotal: new FormControl(0),

            franquiciaBase: new FormControl({ value: 0, disabled: false }),
            franquiciaImpuesto: new FormControl(0),
            franquiciaTotal: new FormControl({ value: 0, disabled: false }),
            InsuranceFranchiseVatCode: new FormControl('', [Validators.required]),
            InsuranceSurveyVatCode: new FormControl('', [Validators.required]),
        });

        if (this.pais === 'fr') {
            this.receptionData.addControl('forfait', new FormControl(forfait));
        }
        if (this.pais === 'pt') {
            this.receptionData.get('checkFranquiciaIVA').disable();
            this.receptionData.get('destinoFranquicia').setValue(2);
        }


    }

    crearFormularios(datosCustomDialog) {

        const recepcionistObject = datosCustomDialog.Receptionist;
        const PreviewedDeliveryDate = datosCustomDialog.PreviewedDeliveryDate;
        const fechaEntrega = this._globals.getDateFormat(PreviewedDeliveryDate);
        const horaEntrega = this._globals.getDateFormatComplete(PreviewedDeliveryDate);

        this.setfiscalCodeOrigen(datosCustomDialog.CustomerFiscalCode);
        let horas = 0;
        let minutos = 0;
        let segundos = 0;
        if (horaEntrega) {
            const HMS = horaEntrega.split(' ');
            const datosHoras = HMS[1];
            const desgloseHoras = datosHoras.split(':');
            horas = Number(desgloseHoras[0]);
            minutos = Number(desgloseHoras[1]);
            segundos = Number(desgloseHoras[2]);
        }

        let auxType = 'T';
        let auxModelDescription = '';
        let auxKM = 0;
        let auxServiceFuelLevel = 0;
        let auxOrganizationNumber = '';
        // auxModelCode = datosCustomDialog['ModelCode'];
        auxModelDescription = datosCustomDialog['ModelDescription']; // es-ap.dev
        auxKM = datosCustomDialog['Km'];
        auxServiceFuelLevel = datosCustomDialog['ServiceFuelLevel'];
        auxOrganizationNumber = datosCustomDialog['OrganizationNumber'];
        auxType = datosCustomDialog['VehicleType'];

        this.formularioPrincipal = new FormGroup({
            vehicleData: new FormGroup({
                Type: new FormControl({ value: auxType, disabled: this.deshabilitarCampos }),
                ModelDescription: new FormControl({ value: auxModelDescription, disabled: this.deshabilitarCampos }, [Validators.required]),
                KM: new FormControl({ value: auxKM, disabled: this.deshabilitarCampos }),
                FuelLevel: new FormControl({ value: auxServiceFuelLevel, disabled: this.deshabilitarCampos }),
                OrganizationNumber: new FormControl({ value: auxOrganizationNumber, disabled: this.deshabilitarCampos }),
            }),
            customerForm: new FormGroup({
                fiscalCode: new FormControl({ value: datosCustomDialog.CustomerFiscalCode, disabled: this.deshabilitarCampos }),
                address: new FormControl({ value: datosCustomDialog.CustomerAddress, disabled: this.deshabilitarCampos }),
                city: new FormControl({ value: datosCustomDialog.CustomerCity, disabled: this.deshabilitarCampos }),
                province: new FormControl({ value: datosCustomDialog.CustomerProvince, disabled: this.deshabilitarCampos }),
                postalCode: new FormControl({ value: datosCustomDialog.CustomerCap, disabled: this.deshabilitarCampos }),
                telephoneHome: new FormControl({ value: datosCustomDialog.CustomerTelephoneHome, disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: datosCustomDialog.TelephonePortable, disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: datosCustomDialog.CustomerEmail, disabled: this.deshabilitarCampos }),
            }),
            formReceptionData: new FormGroup({
                receptionist: new FormControl(recepcionistObject.ReceptionistCode ? recepcionistObject.ReceptionistCode : '**'),
                destination: new FormControl(datosCustomDialog.destination ? datosCustomDialog.destination : '1'),
                locMech: new FormControl(datosCustomDialog.LocMecanica),
                locCar: new FormControl(datosCustomDialog.LocCarroceria),
                observations: new FormControl(datosCustomDialog.Notes),
            }),
            formConfirmation: new FormGroup({
                telephonePortable: new FormControl({ value: datosCustomDialog.ContactPhoneNumber, disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: datosCustomDialog.ContactEmail, disabled: this.deshabilitarCampos }),
                fechaEntrega: new FormControl(fechaEntrega ? fechaEntrega : null, [Validators.required]),
                horasEntrega: new FormControl(horas),
                minutosEntrega: new FormControl(minutos)
            })
        });

        if (this._authService.getDataPais() === 'pt') {
            this.formularioPrincipal.get('customerForm').get('postalCode').setValidators([Validators.pattern(/^\d{4}-\d{3}$|^\d{5}$/g)]);
        }

        this.formularioPrincipal.get('customerForm').get('fiscalCode').valueChanges.subscribe(val => {
            //solo en caso de españa y portugal
            if (val !== '') {
                const b = { fiscalCode: val };
                switch (this.pais) {
                    case 'es':
                        this.validacionFiscalCode(b);
                        break;
                    case 'fr':
                        // no se valida
                        break;
                    case 'pt':
                        this.validacionFiscalCode(b);
                        break;
                }
            }
        });
        this.formularioPrincipal.get('vehicleData').get('KM').valueChanges.subscribe(val => {

            if (Number(val) < this.kilometrosIniciales) {
                this.kilometrosMal = true;
                this.formularioPrincipal.get('vehicleData').get('KM').setErrors({ 'invalidKm': true });
            } else {
                this.formularioPrincipal.get('vehicleData').get('KM').setErrors({ 'invalidKm': null });
                this.formularioPrincipal.get('vehicleData').get('KM').updateValueAndValidity({ emitEvent: false });

                this.kilometrosMal = false;
            }

        });
        this.formularioPrincipal.valueChanges.subscribe(val => {
            this.saveDataForm('gestionOr');
        });

        this.saveDataForm('gestionOr');
        const datosForm = this.formularioPrincipal.getRawValue();
    }

    resetFormularioPrincipal() {
        const auxType = 'T';
        const auxModelDescription = '';
        const auxKM = 0;
        const auxServiceFuelLevel = 0;
        const auxOrganizationNumber = '';
        this.formularioPrincipal = new FormGroup({
            vehicleData: new FormGroup({
                Type: new FormControl({ value: auxType, disabled: this.deshabilitarCampos }),
                ModelDescription: new FormControl({ value: auxModelDescription, disabled: this.deshabilitarCampos }, [Validators.required]),
                KM: new FormControl({ value: auxKM, disabled: this.deshabilitarCampos }),
                FuelLevel: new FormControl({ value: auxServiceFuelLevel, disabled: this.deshabilitarCampos }),
                OrganizationNumber: new FormControl({ value: auxOrganizationNumber, disabled: this.deshabilitarCampos }),
            }),
            customerForm: new FormGroup({
                fiscalCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                address: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                city: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                province: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                postalCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                telephoneHome: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            }),
            formReceptionData: new FormGroup({
                receptionist: new FormControl('**'),
                destination: new FormControl('1'),
                locMech: new FormControl(''),
                locCar: new FormControl(''),
                observations: new FormControl(''),
            }),
            formConfirmation: new FormGroup({
                telephonePortable: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                fechaEntrega: new FormControl(null, [Validators.required]),
                horasEntrega: new FormControl(''),
                minutosEntrega: new FormControl('')
            })
        });

        if (this._authService.getDataPais() === 'pt') {
            this.formularioPrincipal.get('customerForm').get('postalCode').setValidators([Validators.pattern(/^\d{4}-\d{3}$|^\d{5}$/g)]);
        }

        this.saveDataForm('gestionOr');
    }

    crearFormulariosRecuperado(datosCustomDialog) {
        this.setfiscalCodeOrigen(datosCustomDialog.CustomerFiscalCode);

        this.formularioPrincipal = new FormGroup({
            vehicleData: new FormGroup({
                Type: new FormControl({ value: datosCustomDialog.vehicleData.Type, disabled: this.deshabilitarCampos }),
                ModelDescription: new FormControl({ value: datosCustomDialog.vehicleData.ModelDescription, disabled: this.deshabilitarCampos }, [Validators.required]),
                KM: new FormControl({ value: datosCustomDialog.vehicleData.KM, disabled: this.deshabilitarCampos }),
                FuelLevel: new FormControl({ value: datosCustomDialog.vehicleData.FuelLevel, disabled: this.deshabilitarCampos }),
                OrganizationNumber: new FormControl({ value: datosCustomDialog.vehicleData.OrganizationNumber, disabled: this.deshabilitarCampos }),
            }),
            customerForm: new FormGroup({
                fiscalCode: new FormControl({ value: datosCustomDialog.customerForm.fiscalCode, disabled: this.deshabilitarCampos }),
                address: new FormControl({ value: datosCustomDialog.customerForm.address, disabled: this.deshabilitarCampos }),
                city: new FormControl({ value: datosCustomDialog.customerForm.city, disabled: this.deshabilitarCampos }),
                province: new FormControl({ value: datosCustomDialog.customerForm.province, disabled: this.deshabilitarCampos }),
                postalCode: new FormControl({ value: datosCustomDialog.customerForm.postalCode, disabled: this.deshabilitarCampos }),
                telephoneHome: new FormControl({ value: datosCustomDialog.customerForm.telephoneHome, disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: datosCustomDialog.customerForm.telephonePortable, disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: datosCustomDialog.customerForm.email, disabled: this.deshabilitarCampos }),
            }),
            formReceptionData: new FormGroup({
                receptionist: new FormControl(datosCustomDialog.formReceptionData.receptionist),
                destination: new FormControl(datosCustomDialog.formReceptionData.destination),
                locMech: new FormControl(datosCustomDialog.formReceptionData.locMech),
                locCar: new FormControl(datosCustomDialog.formReceptionData.locCar),
                observations: new FormControl(datosCustomDialog.formReceptionData.observations),
            }),
            formConfirmation: new FormGroup({
                telephonePortable: new FormControl({ value: datosCustomDialog.formConfirmation.telephonePortable, disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: datosCustomDialog.formConfirmation.email, disabled: this.deshabilitarCampos }),
                fechaEntrega: new FormControl(datosCustomDialog.formConfirmation.fechaEntrega, [Validators.required]),
                horasEntrega: new FormControl(datosCustomDialog.formConfirmation.horasEntrega),
                minutosEntrega: new FormControl(datosCustomDialog.formConfirmation.minutosEntrega)
            })
        });

        if (this._authService.getDataPais() === 'pt') {
            this.formularioPrincipal.get('customerForm').get('postalCode').setValidators([Validators.pattern(/^\d{4}-\d{3}$|^\d{5}$/g)]);
        }

        this.formularioPrincipal.get('customerForm').get('fiscalCode').valueChanges.subscribe(val => {
            //solo en caso de españa y portugal
            if (val !== '') {
                const b = { fiscalCode: val };
                switch (this.pais) {
                    case 'es':
                        this.validacionFiscalCode(b);
                        break;
                    case 'fr':
                        // no se valida
                        break;
                    case 'pt':
                        this.validacionFiscalCode(b);
                        break;
                }
            }
        });
        this.formularioPrincipal.get('vehicleData').get('KM').valueChanges.subscribe(val => {

            if (Number(val) < this.kilometrosIniciales) {
                this.kilometrosMal = true;
                this.formularioPrincipal.get('vehicleData').get('KM').setErrors({ 'invalidKm': true });
            } else {
                this.formularioPrincipal.get('vehicleData').get('KM').setErrors({ 'invalidKm': null });
                this.formularioPrincipal.get('vehicleData').get('KM').updateValueAndValidity({ emitEvent: false });

                this.kilometrosMal = false;
            }

        });
        this.formularioPrincipal.valueChanges.subscribe(val => {
            this.saveDataForm('gestionOr');
        });
    }

    saveDataForm(cual) {

        if (cual === 'gestionOr') {
            const datosForm = this.formularioPrincipal.getRawValue();
            const auxForm = {
                'form': datosForm
            };
            this._dataSaveService.setFormulario(cual, auxForm);
        } else if (cual === 'recepcionOr') {
            const datosForm = this.receptionData.getRawValue();
            const auxForm = {
                'form': datosForm
            };
            this._dataSaveService.setFormulario(cual, auxForm);
        } else {
            // otro
        }

    }

    setKm(value) {
        this.kilometrosIniciales = Number(value);
    }

    setfiscalCodeOrigen(value) {
        this.fiscalCodeOrigen = value;
    }

    //Esta validacion es para el guardado del formulario . A dia 2-4-2020 se me pide que cambie a permitir guardar
    validacionFiscalCode(b) {
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/ValidateFiscalCode`;

        this._gestionOrService.validateFiscalCode(_URL_, b).subscribe(resp => {
            const auxData = resp.Response;
            if (auxData.IsValid) {
                // es valida
                this.isValidEntryFiscalCode = true;
                //es un codigo valido, ahora hay que ver si esta repetido
                if (this.fiscalCodeOrigen !== b.fiscalCode) {
                    this.estaDuplicadoCodigoFiscal(b);
                }
            } else {
                //No es valida
                this.isValidEntryFiscalCode = false;
            }
        });
    }

    estaDuplicadoCodigoFiscal(codigoFiscal) {
        this.isDuplicateFiscalCode = false;
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/ExistsByFiscalCode`;
        const param = {
            searchValue: codigoFiscal.fiscalCode
        };

        this._gestionOrService.existsByFiscalCode(_URL_, param).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.isDuplicateFiscalCode = auxdata.Data;
            }
        });
    }


    getRandomArbitrary(max, min) {
        return Math.floor(Math.random() * (max - min)) + min;
    }
    getOrdenSeleccionada() {
        return this.ordenSeleccionada;
    }
    setOrdenSeleccionada(value) {
        this.ordenSeleccionada = value;
    }

    getOrdenCompleteSeleccionada() {
        return this.ordenCompleteSeleccionada;
    }
    setOrdenCompleteSeleccionada(value) {
        this.ordenCompleteSeleccionada = value;
    }
}
